// extracted by mini-css-extract-plugin
export var gridContainer = "projectContainer-module--gridContainer--ThwJW";
export var projectBox = "projectContainer-module--projectBox--PGNow";
export var text = "projectContainer-module--text--5xyRC";